import {createSlice} from "@reduxjs/toolkit";

export const authenticatedSlice = createSlice({
  name: 'isAuthenticated',
  initialState: false,
  reducers: {
    loggedIn: _ => true,
    loggedOut: _ => false
  }
})

export const {loggedIn, loggedOut} = authenticatedSlice.actions
export default authenticatedSlice.reducer